import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle } from '@ionic/vue';
import { useSlots } from 'vue'

interface Props {
    shape?: 'square'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicCard',
  props: {
    shape: null
  },
  setup(__props: any) {

const props = __props as {
    shape?: 'square'
};



const slots = useSlots()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), {
    class: _normalizeClass({'square': props.shape == 'square'})
  }, {
    default: _withCtx(() => [
      (_unref(slots).title || _unref(slots).subtitle)
        ? (_openBlock(), _createBlock(_unref(IonCardHeader), { key: 0 }, {
            default: _withCtx(() => [
              (_unref(slots).title)
                ? (_openBlock(), _createBlock(_unref(IonCardTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "title")
                    ]),
                    _: 3
                  }))
                : _createCommentVNode("", true),
              (_unref(slots).subtitle)
                ? (_openBlock(), _createBlock(_unref(IonCardSubtitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "subtitle")
                    ]),
                    _: 3
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})